import { Component, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { ImageService } from 'src/app/service/image.service';


@Component({
  selector: 'app-adventure',
  templateUrl: './adventure.component.html',
  styleUrls: ['./adventure.component.scss']
})
export class AdventureComponent implements OnInit {

  imageList: any = [];
  rowIndex: any = [];

  onTrans: boolean = false;
  onAttr: boolean = false;
  onHome: boolean = false;
  onAccom: boolean = false;
  onFood: boolean = false;

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn")!.style.display = "block";

      document.getElementById("responsive")!.style.color = "black";

      document.getElementById("myTopnav")!.style.backgroundColor = "#ffffffda";
    } else {
      document.getElementById("myBtn")!.style.display = "none";

      document.getElementById("myTopnav")!.style.backgroundColor = "transparent";
    
      document.getElementById("responsive")!.style.color = "black";
      document.getElementById("responsive")!.style.backgroundColor = "transparent";
    }
  }

  // When the user clicks on the button, scroll to Service
  toAttr() {
    document.getElementById('toAttr')?.scrollIntoView({ behavior: 'smooth' })

    this.onTrans = false;
    this.onAttr = true;
    this.onHome = false;
    this.onAccom = false;
    this.onFood = false;

    if (this.onAttr == true) {
      document.getElementById("attr")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("trans")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("adv")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("accom")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("food")!.style.color = "rgb(59, 58, 58)";

    }
  }


  // When the user clicks on the button, scroll to About
  toTrans() {
    document.getElementById('toTrans')?.scrollIntoView({ behavior: 'smooth' })
    this.onTrans = true;
    this.onAttr = false;
    this.onHome = false;
    this.onAccom = false;
    this.onFood = false;
    

    if (this.onTrans == true) {
      document.getElementById("attr")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("trans")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("adv")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("accom")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("food")!.style.color = "rgb(59, 58, 58)";

    }
  }


  // When the user clicks on the button, scroll to Accommodation
  toAccom() {
    document.getElementById('toAccom')?.scrollIntoView({ behavior: 'smooth' })
    this.onTrans = false;
    this.onAttr = false;
    this.onHome = false;
this.onAccom = true;
    this.onFood = false;

    if (this.onAccom == true) {
      document.getElementById("attr")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("trans")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("adv")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("accom")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("food")!.style.color = "rgb(59, 58, 58)";

    }
  }


  // When the user clicks on the button, scroll to Food and Bev
  toFood() {
    document.getElementById('toFood')?.scrollIntoView({ behavior: 'smooth' })
    this.onTrans = false;
    this.onAttr = false;
    this.onHome = false;
    this.onAccom = false;
    this.onFood = true;

    if (this.onFood == true) {
      document.getElementById("attr")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("trans")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("adv")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("accom")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("food")!.style.color = "rgb(255, 146, 5)";

    }
  }


  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })

    this.onTrans = false;
    this.onAttr = false;
    this.onHome = true;
    this.onAccom = false;
    this.onFood = false;

    if (this.onHome == true) {
      document.getElementById("attr")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("trans")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("adv")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("accom")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("food")!.style.color = "rgb(59, 58, 58)";

    }
  }

  constructor(private service: ImageService) {

  }

  transport: any = [];
  attractions: any = [];
  accommodation: any = [];
  food: any = [];
  ngOnInit(): void {
    // this.getImageList();
    this.service.getImageDetails().subscribe((data: any) => {
      this.imageList = data.map((d: any) => {
        return {
          id: d.payload.doc.id,
          ...d.payload.doc.data()

        };
      });
      for (let i of this.imageList) {
        if (i.category == "Transport") {
          this.transport.push(i);
        }
        if (i.category == "Attraction") {
          this.attractions.push(i);
        }
        if (i.category == "Food") {
          this.food.push(i);
        }
        if (i.category == "Accommodation") {
          this.accommodation.push(i);
        }
      }
     /* console.log(this.transport);
      console.log(this.attractions);

      console.log(this.imageList);*/
    });
   //console.log(this.imageList);


  }

  
  myFunction() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }
  //Close Nav
  closeNav() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      
    } else {
      x.className = "topnav";
      document.getElementById("nav")!.style.color = "white";

    }
  }


}
